var shvenergy = shvenergy || {};

shvenergy.installer = (function ($) {
    "use strict";
    var cdnvalue = $("#cdnInput").data("value");
    var searchField = $("#map-searchinput");
    const constBounceKey = 'installer';
    var currentResults = {};
    var countryRestriction = searchField.data("country");
    var autoCompleteSearchResults = $("[data-autocomplete]");
    var installersModule = $(".js-installers-module");
    var installersContainer = $(".js-installers-list");
    var useMyLocationButton = $("[data-currentlocationbutton]");

    var clearSearchResultsButton = $("[data-clear]");
    var searchButton = $("[data-search]");

    //Used for loading more installers on the 'Nearest installers' module
    var loadMoreButton = $(".nearest-installer-results__loadmore__button");

    let installersMarkup = '';

    let isPreferredPartnerLabel = '';
    let isNationalInstallerLabel = '';
    let emailTextMask = '';

    //these two params are used by ShowNearestInstallers module on quote result pages
    var sliceAmount = 4;
    var defaultAmount = sliceAmount;

    var options,
        autocompleteService;

    function init() {

        options = {
            types: [""],
            componentRestrictions: { country: countryRestriction }
        };


        if (searchField.length) {
            autocompleteService = new google.maps.places.AutocompleteService();
        }

        searchField.on("keyup", function (e) {
            if (e.which !== 13) {
                setSuggestions(this.value);
            }

            if (e.which === 13 && this.value.length > 0) {
                getGeometry(searchField.val());
            }

            if (this.value.length === 0) {
                clearSearchResults();
            } else {
                clearSearchResultsButton.show();
            }
        });

        useMyLocationButton.on("click", function () {
            clearAutoCompleteSuggestions();
            findCurrentLocation();
        });


        clearSearchResultsButton.on("click", function () {
            clearSearchResults();
        });

        searchButton.on("click", function () {
            getGeometry(searchField.val());
        });

        if (!navigator.geolocation) {
            useMyLocationButton.hide();
        }


        if ($(".nearest-installer-results").length) {

            loadMoreButton.on("click", function () {
                showMore();
            });

            var address = $("[data-address]").data("address");

            getGeometry(address, false);

        }


    }

    function clearAutoCompleteSuggestions() {
        autoCompleteSearchResults.empty();
    }

    function clearSearchResults() {
        installersModule.hide();
        searchField.val('');
        clearAutoCompleteSuggestions();
        clearSearchResultsButton.hide();
    }

    function onClick() {
        //setPrediction(this.prediction);

        if (this.prediction.place_id) {

            //console.log(this.prediction.place_id);

            //console.log(this.prediction.description);


            //console.log(this.innerText);

            shvenergy.tracking.trackEvent("Installer finder", "searchterm-click", this.innerText);

            searchField.val(this.innerText);

            getGeometry(this.prediction.description);

            clearAutoCompleteSuggestions();
        }
    }

    function findCurrentLocation() {

        let defaultPosition;

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(function (position) {

                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                defaultPosition = pos;

                var latLng = new google.maps.LatLng(pos.lat, pos.lng);
                var geoCoder = new google.maps.Geocoder();
                geoCoder.geocode({ 'latLng': latLng }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {

                        searchField.val(results[0].formatted_address);
                        clearSearchResultsButton.show();
                        getInstallers(results[0].geometry.location);

                    }
                });

            }, function () {
                //for now dont so anything if on error
            });
        } else {
            // Browser doesn't support Geolocation
            useMyLocationButton.hide();
        }
    }

    function getGeometry(address, displayAll = true) {

        clearAutoCompleteSuggestions();

        let geocoder = new google.maps.Geocoder();

        geocoder.geocode({ 'address': address }, function (results, status) {

            //console.log(results);

            if (status === google.maps.GeocoderStatus.OK) {
                //console.log(results[0].geometry.location.lat());
                //console.log(results[0].geometry.location.lng());

                getInstallers(results[0].geometry.location, displayAll);

                clearSearchResultsButton.show();

            } else {
                installersModule.hide();
                console.log("Oops, something went wrong here!");
            }

        });

    }

    function getInstallers(location, displayAll = true) {

        let endpoint = '/api/installer/search';
        //let endpoint = 'https://next.json-generator.com/api/json/get/E13m-GBTE';//testing endpoint

        installersModule.hide();

        $.ajax({
            type: "POST",
            url: endpoint,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({
                location: {
                    lat: location.lat(),
                    lng: location.lng()
                }
            }),
            success: function (data) {
                installersModule.show();

                setLabels(data.Labels);
                renderInstallers(data.Installers);//use only 'data' not 'data.Installers' here if you are using the testing endpoint


                //for nearest installers
                if (!displayAll) {
                    $(".nearest-installer-results").slideDown();
                    $(".service-card-container").hide();
                    showMore();
                }
            },
            error: function (jqXHR, textStatus) {
                console.warn(textStatus);
            }
        });

    }

    function setLabels(labels) {
        //console.log(labels);
        isPreferredPartnerLabel = labels.preferredPartnerLabel;
        isNationalInstallerLabel = labels.nationalInstallerLabel;
        emailTextMask = labels.emailTextMask;
    }

    function createElement(prediction) {
        //console.log(prediction);
        var li = document.createElement("div");
        li.setAttribute("tabindex", "0");
        li.setAttribute("role", "button");
        li.setAttribute("title", prediction.description);
        li.innerHTML = prediction.description;
        li.prediction = prediction;
        var $li = $(li);
        $li.on("click", onClick);
        $li.on("keydown", function (e) {
            if (e.which === 13) {
                $(this).trigger("click");
            }
        });
        return $li;
    }

    function setSuggestions(searchTerm) {
        clearAutoCompleteSuggestions();


        if (searchTerm === currentResults.lastTerm) {
            console.log("Found no need to search right now.");
            return;
        }

        currentResults.lastTerm = searchTerm;

        if (!searchTerm || searchTerm.length < 3) {
            console.log("Found no need to search right now.");
            return;
        }
        currentResults.lastTerm = searchTerm;

        shvenergy.bounce.runNamed(constBounceKey, function () {
            autocomplete(searchTerm);
        }, 400);
    }

    function autocomplete(searchTerm) {
        //console.log("searchTerm: ", searchTerm);
        clearAutoCompleteSuggestions();

        autocompleteService.getPlacePredictions({
            input: searchTerm,
            componentRestrictions: { country: countryRestriction },
            types: ['geocode']
        }, function (predictions, status) {
            if (status !== google.maps.places.PlacesServiceStatus.OK) {
                console.log("Something went wrong. Try again.");
                return;
            }

            buildPredictions(predictions);
        });
    }

    function buildPredictions(predictions) {

        predictions.forEach(function (prediction) {
            //console.log(prediction);
            var newElement = createElement(prediction);
            autoCompleteSearchResults.append($(newElement));
        });
    }

    // Recursively build installers markup
    function renderInstallers(installers) {

        if (!installers) {
            console.warn('No installers');
        }
        if (installersMarkup === '' && installers.length === 0) {
            installersContainer.html("");
            return;
        }
        if (installers && installers.length === 0) {
            installersContainer.html(installersMarkup);
            installersMarkup = '';

           // $('html, body').animate({ scrollTop: $(".js-installers-module").offset().top - 70 }, 800);
            return;
        }

        // Pass first element from articles and generate its markup
        installersMarkup += generateInstallerMarkup(installers.shift());

        // Call function with remaining list
        renderInstallers(installers);
    }

    function generateServicesMarkup(services) {

        let serviceList = "";

        services.forEach(function (service) {
            serviceList += `<li>${service}</li>`;
        });

        return serviceList;
    }

    function generateInstallerMarkup(installer) {
        let certificateIcons = '';
        let trumpet = '';
        let services = '';
        let certificate = '';
        let phone = '';
        let email = '';
        let website = '';
        let address = '';
        let company = '';


        //Used by the prod endpoint
        if (installer.icons.length > 0) {

            certificate += '<div class="service-card__certificates">';
            installer.icons.forEach(cert => {
                if (cert.number) {
                    certificate += `<div class="service-card__certificate">
                                <img src="${cert.icon}" width="32" height="32" alt="" aria-hidden="true" />
								<span class="service-card__certificate-number">${cert.number}</span>
								
							</div>`;
                }
            });
            certificate += '</div>';
        }


        //Used by the testing endpoint
        if (installer.image) {
            certificateIcons = `<div class="service-card__cert-symbol"><img class="service-card__cert-symbol" width="32" height="32" src="${installer.image}" alt="" /></div>`;
        }

        if (installer.isPreferredPartner) {
            trumpet = `<small class="trumpet"><span class="preferred">${isPreferredPartnerLabel}</span></small>`;
        }

        if (installer.isNationalInstaller) {
            trumpet = `<small class="trumpet">${isNationalInstallerLabel}</small>`;
        }

        if (installer.isPreferredPartner && installer.isNationalInstaller) {
            trumpet = `<small class="trumpet"><span class="preferred">${isPreferredPartnerLabel}</span> &#8226; ${isNationalInstallerLabel}</small>`;
        }


        if (installer.company) {
            company = `<strong class="trumpet">${installer.company}</strong>`;
        }

        if (installer.addresslines.length > 0) {
            address = '<p class="address address-one">';
            address += installer.addresslines.join('<br>');
            address += '</p>';
        }


        if (installer.phone) {
            phone = `<a class="service-card__link service-card__link--phone" href="tel: ${installer.phone}" onclick='shvenergy.tracking.trackEvent("Installer finder", "phonenumber-click", "${installer.phone}");'>
							<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="/dist/svgsprite/icons.svg#Phone_16x16"></use></svg>
							${installer.phone}
						</a>`;
        }
        if (installer.email) {
            var emailLabel = installer.email;
            if (emailTextMask != null && emailTextMask != '') {
                emailLabel = emailTextMask;
            }


            email = `<a class="service-card__link" href="mailto: ${installer.email}" onclick='shvenergy.tracking.trackEvent("Installer finder", "email-click", "${installer.email}");'>
							<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#E-mail_16x16"></use></svg>
							<p>${emailLabel}</p>
						</a>`;
        }

        if (installer.website) {
            website = `<a class="service-card__link" href="${installer.website}" onclick='shvenergy.tracking.trackEvent("Installer finder", "website-click", "${installer.website}");'>
								<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Globe_16x16"></use></svg>
							${installer.website}
						</a>`;
        }

        if (installer.services && installer.services.length > 0) {
            services = `<ul>${generateServicesMarkup(installer.services)}</ul>`;
        }

        return `<div class="columns small-12 medium-6 large-4 xlarge-3 service-card-container">
					<div class="service-card">
					<div class="service-card__info">
						${trumpet}
						${company}
						${address}
						${phone}
						${email}
						${website}
						${services}
					</div>
					${certificate}
				
				</div>
			</div>`;
    }

    function showMore() {

        let allItems = $(".service-card-container");
        var amount = allItems.length;
        var newItems = allItems.slice(sliceAmount - defaultAmount, sliceAmount).show();

        if (sliceAmount !== defaultAmount) {

            $('html, body').animate({
                scrollTop: newItems.first().offset().top - 80
            }, 500);
        }

        if (sliceAmount >= amount) {
            loadMoreButton.prop("disabled", true);
        }

        sliceAmount += defaultAmount;
    }

    init();

})(jQuery);